export default {
  created: 'Erstellt am',
  groups: 'Beleggruppen',
  uploadTitle: 'Beleg hochladen',
  notification: {
    save: {
      type: 'success',
      message: 'Gruppe erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    }
  }
}
